module.exports = __webpack_public_path__ + "assets/img/arrow-white.5307eb6c.svg";